import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, FlameIcon } from 'lucide-react';
const OFFERS = [{
  text: '🔥 LIMITED OFFER — $15 OFF GUTTER CLEANING for First-Time Customers 🔥'
}, {
  text: '⭐ $125 OFF New Gutter Installation (100ft+) — Call Today! ⭐'
}, {
  text: '🎖️ $15 OFF Senior Citizen Discount — Licensed & Insured 🎖️'
}];
interface PromoBarProps {
  onClose: () => void;
}
export function PromoBar({
  onClose
}: PromoBarProps) {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % OFFERS.length);
    }, 3500);
    return () => clearInterval(interval);
  }, []);
  return <div className="fixed top-0 left-0 right-0 overflow-hidden" style={{
    zIndex: 60,
    background: 'linear-gradient(135deg, #991B1B 0%, #DC2626 40%, #B91C1C 70%, #991B1B 100%)'
  }} data-id="element-270">
      {/* Shimmer sweep */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden" style={{
      background: 'linear-gradient(105deg, transparent 40%, rgba(255,255,255,0.15) 50%, transparent 60%)'
    }} data-id="element-271">
        <div className="w-full h-full animate-shimmer-sweep" data-id="element-272" />
      </div>

      {/* Top/bottom highlight lines */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/30 to-transparent" data-id="element-273" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" data-id="element-274" />

      <div className="max-w-7xl mx-auto px-4 py-2.5 flex items-center justify-between relative z-10" data-id="element-275">
        {/* Left flame */}
        <div className="hidden sm:flex items-center gap-1.5 flex-shrink-0" data-id="element-276">
          <FlameIcon className="w-4 h-4 text-[#FCA5A5]" data-id="element-277" />
        </div>

        {/* Rotating offer text */}
        <div className="flex-1 flex justify-center items-center h-6 overflow-hidden relative mx-4" data-id="element-278">
          <AnimatePresence mode="wait" data-id="element-279">
            <motion.p key={currentIndex} initial={{
            y: 18,
            opacity: 0
          }} animate={{
            y: 0,
            opacity: 1
          }} exit={{
            y: -18,
            opacity: 0
          }} transition={{
            duration: 0.45,
            ease: [0.22, 1, 0.36, 1]
          }} className="text-sm md:text-base font-bold tracking-wide text-center absolute w-full text-white animate-glow-pulse" data-id="element-280">
              {OFFERS[currentIndex].text}
            </motion.p>
          </AnimatePresence>
        </div>

        {/* Dots + close */}
        <div className="flex items-center gap-3 flex-shrink-0" data-id="element-281">
          <div className="hidden sm:flex gap-1.5" data-id="element-282">
            {OFFERS.map((_, i) => <button key={i} onClick={() => setCurrentIndex(i)} className={`w-1.5 h-1.5 rounded-full transition-all duration-300 ${i === currentIndex ? 'bg-white scale-125' : 'bg-white/40'}`} data-id="element-283" />)}
          </div>
          <button onClick={onClose} className="p-1 hover:bg-white/20 rounded-full transition-colors" aria-label="Close promotion" data-id="element-284">
            <XIcon className="w-3.5 h-3.5 text-white/80" data-id="element-285" />
          </button>
        </div>
      </div>
    </div>;
}